import store from '@/store';
import { repaymentMethodList } from '@/util/dictList.js';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      display: false,
      search: true,
      searchOrder: 444,
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      searchPlaceholder: '请输入租赁人',
      display: false,
      searchOrder: 777,
    },
    {
      label: '所属代理商',
      prop: 'deptName',
    },
    {
      label: '所属代理商',
      prop: 'businessDeptIdList',
      type: "select",
      span: 24,
      display: false,
      search: true,
      filterable: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 999,
      hide: true,
      dicData: store.getters.companies,
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: '产品类型',
      prop: 'rentType',
      type: 'select',
      display: false,
      search: true,
      searchMultiple: false,
      showColumn: false,
      dicData: store.getters.porductTypes,
      searchOrder: 888,
      props: {
        label: 'productName',
        value: 'value',
      },
    },
    {
      label: '平台',
      prop: 'platformId',
      type: 'select',
      display: false,
      search: true,
      showColumn: false,
      hide: false,
      searchOrder: 666,
      dicData: [],
      props: {
        label: "platformName",
        value: "id",
      },
    },
    {
      label: '平台起租日',
      prop: 'leaseDate',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '平台金额',
      prop: 'platformAmount',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '平台还款期数',
      prop: 'repaymentPeriods',
      type: 'select',
      search: false,
      display: true,
      formatter: (val, value, label) => {
        return (value || value === 0) ? value + '期' : ''
      },
    },
    {
      label: '每月还款',
      prop: 'platformRepaymentAmount',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '平台还款日期',
      prop: 'repaymentDate',
      type: 'select',
      search: false,
      display: true,
    },
    {
      label: '平台逾期天数',
      prop: 'platformDelayDays',
      type: 'select',
      search: false,
      display: true,
      hide: true,
    },
    {
      label: '还租状态',
      prop: 'leaseStatus',
      type: 'select',
      dicData: repaymentMethodList,
    },
    {
      label: '代偿状态',
      prop: 'compensationStatus',
      type: 'select',
    },
    {
      label: '结清状态',
      prop: 'settlementStatus',
      type: 'select',
    },
    {
      label: '还款方式',
      prop: 'repaymentMethod',
      type: 'select',
      search: true,
      searchOrder: 555,
      dicData: repaymentMethodList,
    },
    {
      label: 'id',
      prop: 'loanInformationId',
      display: false,
      hide: true,
    },
  ],
};

